import { ReactNode } from "react";

import { ConfigProvider, Layout } from "antd";
import { cx } from "class-variance-authority";

import { TooltipProvider } from "../Tooltip";

import * as theme from "./PageContent.css";

export const PAGE_CONTENT_ID = "app-bar-content";

/**
 * Put on a scrolling element inside `PageContent` to mount antd popups opened
 * from it there, so they scroll along with it.
 */
export const SCROLLABLE_CONTENT_CLASS_NAME = "scrollable-content";

export interface PageContentProps {
    className?: string;
    children: ReactNode;
}

export function PageContent({ className, children }: PageContentProps) {
    return (
        <Layout.Content
            id={PAGE_CONTENT_ID}
            className={cx(theme.content, className)}
        >
            <TooltipProvider>
                <ConfigProvider getPopupContainer={getPopupContainer}>
                    {children}
                </ConfigProvider>
            </TooltipProvider>
        </Layout.Content>
    );
}

function getPopupContainer(triggerNode: HTMLElement | undefined): HTMLElement {
    const pageContent = document.getElementById(
        PAGE_CONTENT_ID
    ) as HTMLDivElement;
    if (!triggerNode) {
        return pageContent;
    }
    const closestScrollableContent = triggerNode.closest(
        `.${SCROLLABLE_CONTENT_CLASS_NAME}`
    );
    if (!closestScrollableContent) {
        return pageContent;
    }

    // We'll trust we won't put the class on elements like images
    return closestScrollableContent as HTMLElement;
}
